module.exports = __webpack_public_path__ + "static/media/SABAH ALNOUR MOSELLI.a07cd94e.png";